import { render, staticRenderFns } from "./EmailMagazineConfirmDialog.vue?vue&type=template&id=c2194c5a&scoped=true"
import script from "./EmailMagazineConfirmDialog.vue?vue&type=script&lang=ts"
export * from "./EmailMagazineConfirmDialog.vue?vue&type=script&lang=ts"
import style0 from "./EmailMagazineConfirmDialog.vue?vue&type=style&index=0&id=c2194c5a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2194c5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2194c5a')) {
      api.createRecord('c2194c5a', component.options)
    } else {
      api.reload('c2194c5a', component.options)
    }
    module.hot.accept("./EmailMagazineConfirmDialog.vue?vue&type=template&id=c2194c5a&scoped=true", function () {
      api.rerender('c2194c5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/EmailMagazineConfirmDialog.vue"
export default component.exports